"use client";
import { PhoneNumber } from "cy-api/simple-payments/common-models";
import { NextLink } from "cy-fe";
import { Button, Label, notify } from "cy-fe";
import { FormEvent, useEffect, useState } from "react";
import * as StepWizard from "cy-ui/components/StepWizard";
import { OtpInput } from "cy-remittance/components/inputs";
import { BodyContainer } from "cy-remittance/components/layouts";
import { HeaderText } from "cy-remittance/components/HeaderText";

export function OtpPage({
  mobile,
  onSubmit,
  resendRequest,
  backUrl,
  startUrl,
}: {
  mobile: PhoneNumber;
  backUrl: string;
  startUrl: string;
  onSubmit: (args: { otp: string }) => Promise<void>;
  resendRequest: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [displayResend, setDisplayResend] = useState(false);

  async function submitHandler(e: FormEvent) {
    e.preventDefault();
    setLoading(true);

    try {
      await onSubmit({ otp });
    } catch (err) {
      // noop
      console.log("otp submit error", err);
      notify("Error", "Error creating customer", { error: err });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDisplayResend(true);
    }, 20000);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <StepWizard.StepPageLayout
      backUrl={backUrl}
      headerRender={() => <HeaderText>Confirm your mobile number</HeaderText>}
      subHeaderRender={() => (
        <>
          We sent a 6 digit code to {`${mobile.isd} ${mobile.number}`}.{" "}
          <NextLink
            className="rounded p-1 font-bold underline underline-offset-2 focus:ring-2"
            href={startUrl}
          >
            Change it?
          </NextLink>
        </>
      )}
    >
      <form onSubmit={submitHandler}>
        <BodyContainer className="mt-10">
          <Label>Your 6-digit code</Label>
          <OtpInput
            length={6}
            numberOnly
            value={otp}
            onChange={(e) => setOtp(e)}
          />

          {displayResend && !loading ? (
            <div className="mt-3">
              Didn&apos;t receive the code?&nbsp;
              <NextLink
                onClick={resendRequest}
                className="rounded p-1 font-bold underline underline-offset-2 focus:ring-2"
                href="#"
              >
                Resend it.
              </NextLink>
            </div>
          ) : null}

          <Button
            className="mt-5 w-full"
            loading={loading}
            type="submit"
            vSize="lg"
          >
            Submit
          </Button>
        </BodyContainer>
      </form>
    </StepWizard.StepPageLayout>
  );
}
